module.exports = __webpack_public_path__ + "static/media/store-gelsons.e3aa9936.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/stores/store-gelsons.jpg
// module id = 230
// module chunks = 0